var _defs, _style, _path, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 31",
    width: 31,
    height: 31,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "plus-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 17,
    height: 17,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAMAAAAMs7fIAAAAAXNSR0IB2cksfwAAAFdQTFRFAAAA/2qH/2qH/2qH/2qH/2qH/2qH/2qH/2qH/2qH/2qH/2qH/2qH/2qH/2qH/2qH/2qH/2qH/2qH/2qH/2qH/2qH/2qH/2qH/2qH/2qH/2qH/2qH/2qHBlGgXQAAAB10Uk5TAEuEB3C8aQmW/I4Bkf6QDRESmP+XDG2GiMxA7Guom4KzAAAAYklEQVR4nGNkgABGxv//oSwIxczIyPgLRYQdKPINRYQbKPKJBBFuBhZGkFWMjH+A3P9/GBhFQTyg0C82oO3/gU5glGJg/MEABxz/sanBNIc890BFmP+jiTDIvBR/giqCCB8ATgcibPQQH0gAAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: none;stroke: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m15.5 0.5c8.3 0 15 6.7 15 15 0 8.3-6.7 15-15 15-8.3 0-15-6.7-15-15 0-8.3 6.7-15 15-15z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Layer 1",
    href: "#img1",
    x: 7,
    y: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.32f318cf4eb41567d7b97679188f1138.svg";
export { ForwardRef as ReactComponent };